import { Phone, Mail } from "lucide-react";
import { PrimaryButton, Reveal } from "@/components/ui-bits";

const FinalCta = ({ headline = "HAVE FREIGHT TO MOVE?" }) => {
  return (
    <section data-testid="final-cta-section" aria-labelledby="final-cta-heading" className="bg-[#191c1e] py-20 text-white sm:py-24 lg:py-28">
      <div className="container-30 grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-7">
          <p className="eyebrow !text-[#ff6a00]" data-testid="section-eyebrow">Get Started</p>
          <h2
            id="final-cta-heading"
            data-testid="final-cta-headline"
            className="mt-6 text-3xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-5xl"
          >
            {headline}
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg">
            Tell us what you're moving, where it's going and when it needs to arrive.
          </p>
          <div className="mt-10">
            <PrimaryButton to="/request-a-quote" testid="final-cta-quote-button">
              REQUEST A QUOTE
            </PrimaryButton>
          </div>
        </Reveal>
        <Reveal delay={0.12} className="lg:col-span-5">
          <div className="border border-[#2b2f33] bg-[#121416] p-8 lg:p-10" data-testid="final-cta-contact-card">
            <h3 className="text-xs font-bold uppercase tracking-[0.22em] text-white/40">Contact 30 NORTH</h3>
            <a
              href="tel:6138700294"
              data-testid="final-cta-phone-link"
              className="mt-6 flex items-center gap-4 text-white transition-colors duration-200 hover:text-[#ff6a00]"
            >
              <Phone className="h-5 w-5 shrink-0 text-[#ff6a00]" aria-hidden="true" />
              <span className="font-display text-xl font-bold tracking-wide sm:text-2xl">613-870-0294</span>
            </a>
            <a
              href="mailto:operations@30north.ca"
              data-testid="final-cta-email-link"
              className="mt-5 flex items-center gap-4 text-white/80 transition-colors duration-200 hover:text-[#ff6a00]"
            >
              <Mail className="h-5 w-5 shrink-0 text-[#ff6a00]" aria-hidden="true" />
              <span className="break-all text-base font-medium">operations@30north.ca</span>
            </a>
            <p className="mt-8 border-t border-[#2b2f33] pt-6 text-sm leading-relaxed text-white/50">
              2907 - 80 Absolute Ave
              <br />
              Mississauga, ON L4Z 0A5
              <br />
              Canada
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCta;
